import Cookies from "js-cookie";

const createSkill = async ({ commit, rootGetters, dispatch }, payload) => {
    commit("SET_SKILL_ACTION_LOADING", true);
    try {
        const customer = rootGetters["customer/CUSTOMER"];
        const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];
        const data = { ...payload, customer_id: customer.customer_id, userId: Cookies.get('userId') };

        if (customer.customer_id === 0) {
            data.customer_id = selected_customer.customer_id;
        }

        const response = await window.axios.post(`/proxy/ai/workspaces/${data.workspaceId}/skills?customer_id=${data.customer_id}`, data);

        if (response && response.data.success) {
            commit('PUSH_TO_SKILLS', response.data.skill);
            return response.data.skill;
        } else {
            throw response.data;
        }
    } catch (error) {
        dispatch("notifications/setError", error.message || "Failed to create skill", { root: true });
        throw error;
    } finally {
        commit("SET_SKILL_ACTION_LOADING", false);
    }
};

export default createSkill;